import axios from 'axios'


export const  api = axios.create({
  baseURL: 'https://api.shareaustralia.com.au/',
  headers: {'X-Custom-Header': 'foobar'}
});
